import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { storeAuthApi } from '../../services/api';

const StoreLogin = () => {
  const navigate = useNavigate();
  const { companySlug } = useParams();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const res = await storeAuthApi.login(values);
      if (res.success) {
        localStorage.setItem('store_token', res.data.token);
        localStorage.setItem('store_admin', JSON.stringify(res.data.storeAdmin));
        message.success('登录成功');
        navigate(`/${companySlug}/store`);
      }
    } catch (error) {
      message.error(error.response?.data?.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f8f6f3 0%, #f0ece5 100%)'
    }}>
      <div style={{
        width: 400,
        padding: 40,
        background: '#fff',
        borderRadius: 12,
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h1 style={{ fontSize: 24, color: '#8B7355', marginBottom: 8 }}>门店登录</h1>
          <p style={{ color: '#999' }}>请输入您的账户信息</p>
        </div>

        <Form
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input size="large" placeholder="用户名" />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password size="large" placeholder="密码" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              block
              loading={loading}
            >
              登录
            </Button>
          </Form.Item>

          <div style={{ textAlign: 'center' }}>
            <a href={`/${companySlug}/admin/login`} style={{ color: '#8B7355' }}>管理员登录</a>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default StoreLogin;
